module.exports = __webpack_public_path__ + "img/49.f4419737.jpg";